/**
 * Created by luohao on 2019/6/12.
 */
const state = {
  modelList: []
};
const getters = {
  getModelList: state => {
    return state.modelList
  }
};
const mutations = {
  uploadModel (state, payload) {
    state.modelList = payload
  }
};
const actions = {

};
export default {
  state,
  getters,
  mutations,
  actions
}
